import { combineReducers } from 'redux';
import setTeamColorsModalReducer from './set-team-colors-modal.slice'

const teamRootReducer = combineReducers({
    setTeamColorsModal: setTeamColorsModalReducer,
});

export default teamRootReducer;